export default __webpack_public_path__ + "ab6274f15af7797410bd7d45cf72ada7.jpeg";